module.exports = __webpack_public_path__ + "Roboto-Regular.2751ee43015f9884c364.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Regular.woff2
// module id = ../../../../../src/assets/font/roboto/Roboto-Regular.woff2
// module chunks = 29